import React, { Fragment, useEffect, useState } from "react";
import { Card, Typography, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import ScrollbarContainer from "../../../components/ScrollBar/CustomScrollbar";

const UsuariosTabla = (props) => {
  const { usuarios, especialidades } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  useEffect(() => {
    setUsuariosFiltrados(usuarios);
  }, [usuarios]);

  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: 5,
        marginBottom: 2,
        p: 0,
        backgroundColor: 'white',
      }}
    >
      <ScrollbarContainer>
        <Table
          sx={{
            backgroundColor: 'white',
          }}
        >
          <TableHead>
            <TableCell
              sx={{
                color: 'primary.textDark',
                fontSize: '15px',
              }}
            >
              Nombre
            </TableCell>
            <TableCell
              sx={{
                color: 'primary.textDark',
                fontSize: '15px',
              }}
            >
              Correo
            </TableCell>
            <TableCell
              sx={{
                color: 'primary.textDark',
                fontSize: '15px',
              }}
            >
              Rol
            </TableCell>
            <TableCell
              sx={{
                color: 'primary.textDark',
                fontSize: '15px',
              }}
            >
              Fecha de creación
            </TableCell>
          </TableHead>
          <TableBody>
            {usuariosFiltrados?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => (
              <Fragment key={user.id}>
                <TableRow
                  hover
                  key={user.id}
                >
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {user?.nombre}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {user?.correo}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {user?.rol}
                    </Typography>

                    {
                      user?.rol === 'Medico' &&
                      <Typography
                        variant="body2"
                        color="primary.textDark"
                      >
                        {especialidades?.find((especialidad) => especialidad.id === user?.user)?.nombre}
                      </Typography>
                    }
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {new Date(user?.createdAt).toLocaleDateString()}
                    </Typography>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[40, 80, 120]}
          component='div'
          count={usuariosFiltrados?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          labelRowsPerPage='Filas por página'
        />
      </ScrollbarContainer>
    </Card >
  );
}

export default UsuariosTabla;